<template>
  <v-layout align-center >
    <v-layout align-center class="hint-bar-container">
      <span class="hint-bar-divider-line vertical-divider-line vertical-divider-line-white">
      </span>
      <v-icon class="hint-bar-icon">{{ icon }}</v-icon>
      <div class="slot-wrapper">
        <slot name="content" class="hint-bar-content" />
      </div>
    </v-layout>
  </v-layout>
</template>

<script>
import '../../../style/_variables.scss'
export default {
  name: 'HintBar',
  props: {
    icon: {
      default: 'info'
    }
  }
}
</script>

<style scoped lang="scss">
.hint-bar {
  &-container {
    background-color: $bg-primary;
    border-radius: 8px;
    position: relative;
    border: 3px solid $grey-400;
    outline: 10px solid $bg-primary;
    padding: 5px 10px 5px 10px;
    width: fit-content;
    max-width: 90%;
  }
  &-divider-line {
    height: 75%;
    position: absolute;
    width: 1.5px;
    background-color: $grey-500;
  }
  &-icon {
    color: $grey-500;
    margin: 0 5px;
  }
}
.slot-wrapper > * {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/utils/HintBar.vue